import CalculatedResultIcon from './calculated-result-icon';
export default CalculatedResultIcon;
